import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "size-thickness"
};
var _hoisted_2 = {
  class: "label"
};
var _hoisted_3 = {
  class: "selected"
};
var _hoisted_4 = ["onClick"];
import { ref, computed } from 'vue';

/* 变量 */

export default {
  __name: 'SizeThickness',
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var props = __props;
    var emit = __emit;
    var brushOptions = [{
      label: '细',
      value: 2
    }, {
      label: '中',
      value: 4
    }, {
      label: '粗',
      value: 6
    }];
    var rubberOptions = [{
      label: '小',
      value: 6
    }, {
      label: '中',
      value: 10
    }, {
      label: '大',
      value: 12
    }];
    var textOptions = [{
      label: '小',
      value: 14
    }, {
      label: '中',
      value: 18
    }, {
      label: '大',
      value: 24
    }];
    var showSelect = ref(false);

    /* 计算属性 */
    var label = computed(function () {
      var label = '';
      if (props.type === 'brush') {
        label = '粗细';
      } else {
        label = '大小';
      }
      return label;
    });
    var options = computed(function () {
      var options = [];
      if (props.type === 'brush') {
        options = brushOptions;
      } else if (props.type === 'rubber') {
        options = rubberOptions;
      } else if (props.type === 'text') {
        options = textOptions;
      }
      return options;
    });
    var checkItem = computed(function () {
      var _options$value;
      return (_options$value = options.value) === null || _options$value === void 0 ? void 0 : _options$value.find(function (e) {
        return e.value === props.modelValue;
      });
    });
    var wClass = computed(function () {
      return props.type === 'brush' ? 'w90' : 'w70';
    });

    /* 事件 */
    // 点击选择
    var handleClick = function handleClick(item) {
      showSelect.value = false;
      if (item.value === props.modelValue) return;
      emit('update:modelValue', item.value);
      emit('change', item.value);
    };
    return function (_ctx, _cache) {
      var _checkItem$value;
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(label.value), 1), _createElementVNode("div", {
        class: _normalizeClass(["select-box", wClass.value]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return showSelect.value = true;
        })
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString((_checkItem$value = checkItem.value) === null || _checkItem$value === void 0 ? void 0 : _checkItem$value.label), 1), __props.type === 'brush' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "line",
        style: _normalizeStyle({
          height: "".concat(__props.modelValue, "px")
        })
      }, null, 4)) : _createCommentVNode("", true)]), _createVNode(_component_svg_icon, {
        name: "select"
      }), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["select-list", wClass.value])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.value,
          class: _normalizeClass(["select-item", {
            'active-item': __props.modelValue === item.value
          }]),
          onClick: _withModifiers(function ($event) {
            return handleClick(item);
          }, ["stop"])
        }, [_createElementVNode("span", null, _toDisplayString(item.label), 1), __props.type === 'brush' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "line",
          style: _normalizeStyle({
            height: "".concat(item.value, "px")
          })
        }, null, 4)) : _createCommentVNode("", true)], 10, _hoisted_4);
      }), 128))], 2), [[_vShow, showSelect.value]])], 2)]);
    };
  }
};